export default "__VITE_ASSET__9dQya50k__"